var exports = {
  "x6": "MemberListItem.module__button___MjkyMU",
  "OG": "MemberListItem.module__nameRoleColored___MjkyMU",
  "w1": "MemberListItem.module__buttonOffline___MjkyMU",
  "dP": "MemberListItem.module__buttonContextMenuOpen___MjkyMU",
  "vs": "MemberListItem.module__memberFocusRing___MjkyMU",
  "Vg": "MemberListItem.module__grid___MjkyMU",
  "Qs": "MemberListItem.module__content___MjkyMU",
  "H": "MemberListItem.module__avatarContainer___MjkyMU",
  "TT": "MemberListItem.module__userInfoContainer___MjkyMU",
  "VW": "MemberListItem.module__nameContainer___MjkyMU",
  "UU": "MemberListItem.module__name___MjkyMU",
  "w4": "MemberListItem.module__memberCustomStatus___MjkyMU",
  "Dd": "MemberListItem.module__ownerIcon___MjkyMU",
  "j$": "MemberListItem.module__crownIcon___MjkyMU",
  "a1": "MemberListItem.module__userTag___MjkyMU",
};

module.exports = exports;
